
    import { Component, Vue } from 'vue-property-decorator';
    import API from '@/store/userAPI';
    

    @Component
    export default class Users extends Vue {
        users: any = []
            private mounted() {
                API.getUsers().then(response => (this.users = response))
                }
            
        private async deleteuser(user: Users) {
            console.log(user);
            var userParsed = JSON.parse(JSON.stringify(user))
           
            if (userParsed.id>0 ) {
                if (confirm("Are you sure you want to delete the Tag?")) {
                    await API.deleteUser(userParsed.id).then((result) => {

                        //alert(userParsed.id);
                        console.log(result);
                        
                        this.users.splice(this.users.indexOf(user),1)
                    });
                }
            }
        } 

        private async edituser(user: Users) {
            console.log(user);
            var userParsed = JSON.parse(JSON.stringify(user))

            if (userParsed.id > 0) {                
               
                this.$router.push({ name: "UsersEdit", params: { userId: userParsed.id } });
                    
                
            }
        } 
    }

